import KeyResult from './KeyResult';

export default KeyResult;
